// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"f89c959e","131":"43a853b0","171":"5568649f","374":"22d5a105","443":"c507b910","895":"3b4bcd31"}[chunkId] + ".chunk.js";
};